// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3muPR","select":"Header_select__7IDS4","clinic":"Header_clinic__279_b"};